import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { SelectCaseDialogComponent } from '../selectCaseDialog/select-case-dialog.component';
import { CaseView } from 'src/app/digigov/models/caseview.model';
import { TranslateService } from '@ngx-translate/core';
export interface Sender {
  docId: number;
  alphanum_Fileno: string;
  process: string;
  recipient: { empName: string; unitId: number }[];
  selectedRadio: {
    empName: string;
    unitId: number;
    toOrderNo: number;
    roleId: number;
    mpgType: number;
    subHrchyLvlPk: number;
  };
  showMsg: boolean;
  // target:string;
}
export interface FileHierarchy {
  empId: number;
  empName: string;
  recNo: string;
  recId: number;
  refId: number[];
  unitId: number;
}
export interface ForwardData {
  customXidBean: string;
  dbSchema: string;
  extendedVO: string;
  fileHierarchyVOArr: FileHierarchy[];
  ms: string;
  recId: number;
  recNo: string;
  subjectName: string;
  msg: string;
}

export class customData {
  selectedData: CaseView[];
  isFromCustomAction: boolean;
}
@Component({
  selector: 'app-dg-return',
  templateUrl: './dg-return.component.html',
  styleUrls: ['./dg-return.component.scss'],
})
export class DgReturnComponent implements OnInit {
  dataSource: Sender[];
  /*SENDER_DATA: Sender[] = [
    {alphanum_Fileno: 1, subject: 'notery1',recipient: ['Mr.Shah' , 'Mr. Patel']},
    {alphanum_Fileno: 2, subject: 'notery2',recipient: ['Mr.Desai', 'Mrs.Dsouza']}
    ]*/
  SENDER_DATA: Sender[] = [];
  singleData: Sender = {
    docId: null,
    alphanum_Fileno: null,
    process: null,
    recipient: [],
    selectedRadio: null,
    showMsg: false,
  };
  showTable = false;
  caseData: CaseView[] = [];
  refIdList = '';
  selectedRadio: { empName: string; unitId: number };
  showMsg = false;
  postData = {
    refId: [],
    toUnit: [],
    toOrderNo: [],
    roleId: [],
    toMpgType: [],
    applTypeId: 1,
    movmentActionFlag: 2,
    fromGrpId: null,
    toGrpId: null,
    fromType: null,
    toType: null,
    toRoleId: null,
    delegationVO: null,
    fromGrpWS: null,
    groupLevel: null,
    groupUnitId: null,
    groupId: null,
    recall: null,
    papsFlag: false,
    line: null,
    subHrhcyLvlPk: null,
  };
  docId: number;
  recep = {};
  displayedColumns: string[] = ['alphanum_Fileno', 'process', 'recipient'];
  selectedUnit: any;
  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: customData,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<DgReturnComponent>,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.caseData = this.data?.selectedData;
    let s: any;
    //created to generate comma seperated caseIds
    for (s of this.caseData) {
      this.refIdList += s.docId.toString() + ',';
    }

    this.refIdList = this.refIdList.slice(0, -1);
    let params = new HttpParams();
    //this.docId =  this.caseData.docId
    params = params.append('appTypeId', s?.appTypeId === '3' ? '3' : '1');

    params = params.append('refId', this.refIdList);
    params = params.append('actionId', '611');
    params = params.append('recNo', this.refIdList);
    //params = params.append('organizationId', '70003474');
    this.http
      .get('/workflow/hierarchy-details', { params: params })
      .subscribe((res: { data: ForwardData[] }) => {
        const restemp: { data: ForwardData[] } = res;
        this.showTable = true;

        if (!restemp.data.length) {
          this.singleData.recipient.push({
            empName: 'No person is mapped below you',
            unitId: 0,
          });
          this.singleData.showMsg = true;
          //this.showMsg = true;
        } else {
          this.singleData.showMsg = false;
          //this.showMsg = false;
          for (const val of this.caseData) {
            this.singleData.alphanum_Fileno = val.docNo;
            this.singleData.process = val.subject;
            this.singleData.docId = val.docId;

            for (const s of restemp.data) {
              if (s.recId == val.docId) {
                const fileH: any = s.fileHierarchyVOArr;
                if (!fileH || fileH.length === 0) {
                  this.singleData.recipient.push({ empName: s.msg, unitId: 0 });
                  this.singleData.showMsg = true;
                  //this.showMsg = true;
                } else {
                  for (const m of fileH) {
                    const recep = {
                      empName: m.empName,
                      unitId: m.unitId,
                      unitName: m.unitName,
                      toOrderNo: m.unitLevel,
                      mpgType: m.mpgTyp,
                      roleId: m.nextRole,
                      subHrchyLvlPk: m.subHrchyLvlPk,
                    };
                    if (!recep.empName) {
                    } else {
                      this.singleData.recipient.push(recep);
                    }
                  }
                }
              }
              // else {
              //   this.singleData.recipient = 'No person is mapped above you';
              // }
            }
            this.SENDER_DATA.push(this.singleData);
            this.singleData = {
              docId: null,
              alphanum_Fileno: null,
              process: null,
              recipient: [],
              selectedRadio: null,
              showMsg: false,
            };
          }
        }
        this.dataSource = this.SENDER_DATA;
      });
  }

  /*onClose(): void {
    this.dialogRef.close();
  }*/

  onSend(): void {
    let flag = 0;
    for (const s of this.dataSource) {
      this.postData.refId.push(Number(s.docId));
      if (!s.selectedRadio) {
        flag++;
      } else {
        this.postData.applTypeId = this.caseData[0]?.appTypeId === '3' ? 3 : 1;
        this.postData.toUnit.push(s.selectedRadio.unitId);
        this.postData.toOrderNo.push(s.selectedRadio?.toOrderNo);
        this.postData.toMpgType.push(s.selectedRadio?.mpgType);
        this.postData.subHrhcyLvlPk?.push(s.selectedRadio?.subHrchyLvlPk);
        if (s.selectedRadio?.mpgType === 657) {
          this.postData.roleId.push(s.selectedRadio?.roleId);
        } else {
          this.postData.roleId.push(-1);
        }
      }
    }
    if (flag) {
      this.dialog.open(SelectCaseDialogComponent, {
        data: this.translate.instant('dg_return.PleaseSelect'),
      });
    } else {
      if (!this.data?.isFromCustomAction) {
        this.http.post('/workflow/workflow-operation', this.postData).subscribe(
          (res) => {
            this.dialogRef.close(true);
          },
          (error) => {
            this.dialogRef.close(false);
          }
        );
      } else {
        this.dialogRef.close(this.postData);
      }
    }
  }
  handleChange(event, actionName): void {
    console.log('on radio change', event);
    event.value.actionType = actionName;
    this.selectedUnit = event?.value;
  }

  isButtonDisable(): boolean {
    const hasUnselectedRecipient = this.dataSource.some(
      (s) => !s.selectedRadio
    );

    return hasUnselectedRecipient;
  }
}
